export const OBJECT_TYPE = 'object';
export const PREFERED_COLUMN = ['name', 'ean'];
export const PREFERED_COLUMN_ORDER = ['ean', 'name', 'name_split'];
export const NAME_SPLIT_FIELD = 'name_split';
export const NON_VISIBLE_FIELDS = [
    'id',
    'company',
    'country',
    'name_split',
    'upc',
    'is_ean_defined',
    'category',
    'subcategory',
    'segment',
    'brand',
    'market',
    'tag_weights',
];
export const USELESS_KEY = ['id', 'company', 'country'];
export const RETAILER_ONLY_ATTR = [
    'max_recommended_price',
    'min_recommended_price',
    'recommended_price',
    'products_by_packaging',
    'average_weekly_sales',
    'name',
    'name_split',
    'status',
];
export const RETAILER_AND_LANGUAGE_ATTR = ['name', 'name_split'];
export const EXCEL_FILE_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const EXCEL_FILE_TYPES = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/x-iwork-numbers-sffnumbers',
];

export const GENERIC_EXCEL_FILE_TYPE = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
    'application/vnd.ms-excel.sheet.macroenabled.12',
    'application/vnd.oasis.opendocument.spreadsheet',
    'application/vnd.ms-excel.sheet.binary.macroenabled.12',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
    'application/vnd.ms-excel.sheet.macroenabled.12',
    'application/vnd.oasis.opendocument.spreadsheet',
    'application/vnd.ms-excel.sheet.binary.macroenabled.12',
    'text/csv',
    'application/csv',
    'text/comma-separated-values',
    'application/excel',
];
export const STANDARD_FIELDS = [
    'ean',
    // upc
    'category',
    'subcategory',
    'segment',
    'group',
    'brand',
    'pe',
    'market',
    'mrdr',
    'country',
    'company',
];

export const CUSTOM_FIELDS = [
    'PMCmin',
    'PMCmax',
    'pmc',
    'pcb',
    'vmh',
    'name',
    'status',
    'name_split',
    'blockbuster',
    'valuation',
    'packaging',
    'max_recommended_price',
    'min_recommended_price',
    'recommended_price',
    'products_by_packaging',
    'average_weekly_sales',
    'name_split_facultative',
];

export const PRODUCT_DEFAULT_FIELDS = [...STANDARD_FIELDS, ...CUSTOM_FIELDS];
export const USA_ID = 840;
export const CANADA_ID = 124;
export const MAX_SIZE_EAN = 40;
